import { createFileRoute } from '@tanstack/react-router';
import { JobRunnerConsole } from '@/features/admin/JobRunnerConsole';

/**
 * Job schedulati (super-admin) — Fase 1 del BE: catalogo con pianificazione e ultima
 * esecuzione, esecuzione on-demand, storia dei run con log. `cancel` e `dry-run` sono
 * fuori perimetro dichiarato.
 */
export const Route = createFileRoute('/_app/admin/jobs')({ component: JobRunnerConsole });
